<template>
  <el-container class="GlassContractImport">
    <el-main class="p-0 mb-default">
      <div class="flex">
        <div>
          <el-upload
            action="#"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="handleOnChange"
          >
            <el-button type="info">엑셀 파일</el-button>
          </el-upload>
        </div>
        <div class="ml-default">{{ file_name }}</div>
      </div>
      <div
        v-if="items.length > 0"
        class="of-auto mt-default"
        style="max-height: 332px;"
      >
        <ATable
          class="no-pointer"
          :data="items"
          :row-class-name="resolveRowClassName"
          border
          hide-top-panel
          hide-button-insert
          hide-pagination
        >
          <el-table-column prop="no" label="No" :width="$width.indexw" />
          <el-table-column prop="name" label="품목명" />
          <el-table-column prop="color" label="색상" />
          <el-table-column
            prop="thickness"
            label="두께"
            width="50"
            class-name="cell-number"
          />
          <el-table-column
            prop="horizontal"
            label="가로"
            width="50"
            class-name="cell-number"
          />
          <el-table-column
            prop="vertical"
            label="세로"
            width="50"
            class-name="cell-number"
          />
          <el-table-column
            prop="amount"
            label="수량"
            width="50"
            class-name="cell-number"
          />
          <el-table-column prop="desc" label="비고" />
          <el-table-column prop="field" label="현장" />
          <el-table-column label="실패 이유" :formatter="resolveReason" />
        </ATable>
      </div>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        :disabled="items.length < 1 || fail_count > 0"
        @click="handleRegister"
        >등 록</el-button
      >
      <el-button @click="handleClickClose" class="right"
        >{{ $t("button.close") }} (Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { mapGetters } from "vuex";
import XLSX from "xlsx";
import moment from "moment";
import { Trade } from "@/common/function/class";

export default {
  name: "GlassContractImport",
  data() {
    return {
      title: "유리엑셀등록",
      file_name: "",
      items: [],
      fail_count: 0,
      contract_date: "",
      delivery_date: "",
    };
  },
  computed: {
    ...mapGetters([
      "table_glass_color",
      "table_glass_thickness",
      "table_product",
      "table_option",
      "table_door_color",
      "table_product_glass_price",
      "table_product_price",
      "table_product_door_color_price",
    ]),
  },
  methods: {
    loadExcel(e) {
      let tmpResult = {};
      let data = e.target.result;
      data = new Uint8Array(data);
      // get excel file
      let excelFile;
      try {
        excelFile = XLSX.read(data, { type: "array" });
      } catch (ex) {
        this.file_name = "";
        this.util.notify_error(this, this.title, "엑셀 파일이 아닙니다.");
        return;
      }
      // get prased object
      excelFile.SheetNames.forEach(function(sheetName) {
        const roa = XLSX.utils.sheet_to_json(excelFile.Sheets[sheetName], {
          header: [
            "no",
            "name",
            "color",
            "thickness",
            "horizontal",
            "vertical",
            "amount",
            "desc",
            "field",
          ],
        });
        if (roa.length) tmpResult[sheetName] = roa;
      });
      this.parseExcel(tmpResult.Sheet1);
    },
    parseExcel(result) {
      let data, item;
      let items = [];
      let items_fail = [];
      this.contract_date = "";
      this.delivery_date = "";
      this.fail_count = 0;
      for (let i = 0; i < result.length; i++) {
        data = result[i];
        if (!Number.isInteger(data.no) || !data.name) {
          if (data.no === "발주") {
            this.contract_date = moment("1900-01-01")
              .add(data.name - 2, "d")
              .format("YYYY-MM-DD");
            this.delivery_date = moment("1900-01-01")
              .add(data.horizontal - 2, "d")
              .format("YYYY-MM-DD");
          }
          continue;
        }
        const product = this.table_product.find((x) => x.name === data.name);
        item = this.util.clone(data);
        if (!product) {
          this.fail_count++;
          items_fail.push(item);
        } else {
          item.code = product.code;
          item.kind = product.kind;
          item.product_id = product.id;
          item.product_name = product.name;
          if (item.kind === "GLASS") {
            const [return_items_fail, return_items] = this.setGlassData(item);
            items = [...items, ...return_items];
            items_fail = [...items_fail, ...return_items_fail];
          } else if (item.kind === "DOOR") {
            const [return_items_fail, return_items] = this.setDoorData(item);
            items = [...items, ...return_items];
            items_fail = [...items_fail, ...return_items_fail];
          } else if (item.kind === "GOODS") {
            item.color_id = "-";
            item.thickness_id = "-";
            item.price_id = "-";
            const [descriptions, desc] = this.setDescriptions(item.desc);
            item.desc = desc;
            item.options = {
              descriptions: descriptions,
              specifications: [],
            };
            items.push(item);
          } else {
            item.color_id = "-";
            item.thickness_id = "-";
            item.price_id = "-";
            items.push(item);
          }
        }
      }
      this.items = items_fail.concat(items);
    },
    setGlassData(item) {
      let color = null,
        thickness = null,
        price = null;
      const items_fail = [],
        items = [];
      color = this.table_glass_color.find(
        (c) => c.name.trim() === item.color?.replace("[강화]", "").trim()
      );
      if (color) {
        item.color_id = color.id;
        item.color_name = color.name;
      }
      thickness = this.table_glass_thickness.find(
        (t) => t.name.trim() === item.thickness?.replace("T", "").trim()
      );
      if (thickness) {
        item.thickness_id = thickness.id;
        item.thickness_name = thickness.name;
      }
      if (color && thickness) {
        price = this.table_product_glass_price.find(
          (p) =>
            p.glass_color_id === color.id &&
            p.glass_thickness_id === thickness.id
        );
        item.price_id = price.id;
      }
      let glass_chamfer_type = "no_chamfer";
      let glass_chip_count = 0;
      if (item.desc) {
        const descs = item.desc.split(";");
        const chamfer = descs.filter((d) => d.includes("면취"))[0];
        if (chamfer === "면취무") {
          glass_chamfer_type = null;
        } else if (chamfer) {
          const pre_chamfer = chamfer.split("면취")[0];
          const data = this.system.options.glass_chamfer_type.find(
            (c) => c.label === pre_chamfer
          );
          if (data) {
            glass_chamfer_type = data.value;
          }
        }
        const chip = descs.filter((d) => d.includes("따내기:"))[0];
        if (chip) {
          glass_chip_count = chip.match(/\d+/)?.[0] ?? null;
        }

        item.desc = descs.map((d) => d.trim()).join(" ");
      }
      if (
        !color ||
        !thickness ||
        !price ||
        !item.horizontal ||
        !item.vertical
      ) {
        this.fail_count++;
        item.price_id = null;
        items_fail.push(item);
      } else {
        item.options = {
          glass_pyung: this.util.calculatePyung(
            item.horizontal,
            item.vertical,
            true
          ),
          glass_color_id: item.color_id,
          glass_color_name: item.color_name,
          glass_thickness_id: item.thickness_id,
          glass_thickness_name: item.thickness_name,
          glass_chamfer_type,
          glass_chip_count,
          glass_punching_price: 0,
          glass_processing_price: 0,
        };
        items.push(item);
      }
      return [items_fail, items];
    },
    setDoorData(item) {
      let color = null,
        price = null;
      const items_fail = [],
        items = [];
      color = this.table_door_color.find((c) => c.name.trim() === item.color);
      if (color) {
        item.color_id = color.id;
        item.color_name = color.name;
      }
      if (color) {
        price = this.table_product_door_color_price.find(
          (p) => p.door_color_id === color.id
        );
        item.price_id = price.id;
      }
      const [descriptions, desc] = this.setDescriptions(item.desc);
      item.desc = desc;
      if (!color || !price) {
        this.fail_count++;
        items_fail.push(item);
      } else {
        item.thickness_id = "-";
        item.options = {
          descriptions: descriptions,
          door_assemble_date: null,
          door_assemble_flag: "N",
          door_color_id: item.color_id,
          door_knob: null,
          door_knob_flag: "N",
          specifications: [],
        };
        items.push(item);
      }
      return [items_fail, items];
    },
    setDescriptions(desc) {
      let descriptions = [];
      if (desc) {
        const descs = desc.split(";");
        descs.map((d) => {
          const option = this.table_option.find((o) => o.name === d.trim());
          if (option) descriptions.push(option);
        });
        desc = descs.join(" ");
      }
      return [descriptions, desc];
    },
    resolveRowClassName({ row /*, rowIndex*/ }) {
      return !row.price_id ? "error-row" : null;
    },
    resolveReason(item) {
      if (!item.product_id) {
        return "등록되지 않은 품목";
      } else if (!item.color_id) {
        return "색상 불일치";
      } else if (!item.thickness_id) {
        return "두께 불일치";
      } else if (item.kind === "GLASS") {
        if (!item.horizontal) {
          return "가로 규격 누락";
        } else if (!item.vertical) {
          return "세로 규격 누락";
        }
      } else if (!item.price_id) {
        return "색상에 미등록된 두께";
      } else {
        return "";
      }
    },
    handleOnChange(event) {
      const file = event.raw;
      this.file_name = file.name;
      const reader = new FileReader();
      reader.onload = this.loadExcel;
      reader.readAsArrayBuffer(file);
    },
    handleRegister() {
      let items = [];
      this.items.forEach((d) => {
        let item = new Trade();
        item.id = 0;
        item.code = d.code;
        item.product_id = d.product_id;
        item.product_name = d.name;
        if (d.kind === "DOOR") item.door_color_id = d.color_id;
        if (d.kind === "DOOR" || d.kind === "GLASS")
          item.size =
            "" +
            (d.horizontal ? d.horizontal : 0) +
            "*" +
            (d.vertical ? d.vertical : 0);
        else item.size = d.horizontal;
        item.amount = d.amount;
        item.desc = d.desc;
        item.product_kind = d.kind;
        item.options = d.options;
        item.field = d.field;
        items.push(item);
      });
      let data = {
        contract_date: this.contract_date,
        delivery_date: this.delivery_date,
        details: items,
      };
      this.$emit("completed", data);
    },
    handleClickClose() {
      this.$emit("completed");
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .error-row {
  color: red;
}
</style>
